import React from 'react';
import classnames from 'classnames';
import TextRenderer from '../../../TextRenderer';
import StatusViewer from '../../../DaEditorWrapper/Viewer/Status';
import { getIsShortStatus } from '../../_helpers';
import s from './Status.scss';
export var StatusFullView = function (_a) {
    var _b = _a.deviation, status = _b.status, textContent = _b.textContent, deviation = _a.deviation;
    if (!status) {
        return null;
    }
    if (!textContent || !(textContent.excerpt || textContent.html.markup)) {
        return null;
    }
    // Display logic
    // Legacy gets its own styles
    // If any media inserted it cant be short
    var isLegacy = textContent.html.type === 'writer';
    var isShortStatus = getIsShortStatus(deviation);
    return (React.createElement("div", { className: classnames(s['root'], isLegacy && s['legacy'], isShortStatus && s['short-status'], isShortStatus && 'da-editor-status-short' // flag for editor internals
        ) },
        React.createElement(TextRenderer, { textContent: textContent, className: s['text'], reactViewer: StatusViewer, legacyTheme: isShortStatus ? 'short-status' : 'status' })));
};
StatusFullView.displayName = 'StatusFullView';
export default StatusFullView;
//# sourceMappingURL=Status.js.map